var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFourLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.533,
    height: 45.774,
    viewBox: "0 0 46.533 45.774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22509",
    "data-name": "Group 22509",
    transform: "translate(-134.563 -544.616)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21685",
    "data-name": "Group 21685",
    transform: "translate(134.563 544.616)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50768",
    "data-name": "Path 50768",
    d: "M150.646,551.252c6.273-.014,12.532-.15,18.8-.45l2.345-.123c5.059.273,9.791-4.214,9.232-9.218-.518-7.036-1-14.1-1.309-21.15a7.03,7.03,0,0,0-6.845-7.582q-9.409,0-18.8-.436l-2.345-.123a7.867,7.867,0,0,0-9.218,7.05c-.464,6.273-.886,12.532-1.2,18.8-.027,1.555-.232,3.164-.109,4.664a9.573,9.573,0,0,0,9.45,8.564Zm0,0a10.183,10.183,0,0,1-9.954-8.5c-.218-1.623-.191-3.15-.286-4.732-.314-6.273-.736-12.532-1.2-18.8a11.809,11.809,0,0,1,4.527-9.914,13.111,13.111,0,0,1,8.018-2.618l2.345-.123q9.409-.45,18.8-.436A12.923,12.923,0,0,1,185.637,520.3l-.109,2.345c-.314,6.273-.736,12.532-1.2,18.8a11.541,11.541,0,0,1-1.6,5.127,11.126,11.126,0,0,1-10.909,5.236l-2.345-.123c-6.3-.273-12.559-.423-18.832-.436Z",
    transform: "translate(-139.184 -506.129)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_4",
    "data-name": 4,
    transform: "translate(152.123 577.496)",
    fill: "#fff",
    fontSize: 25,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourLabel);
export default __webpack_public_path__ + "static/media/four_label.c07b3f3a30383debcc4e2825d77eaf41.svg";
export { ForwardRef as ReactComponent };